export const TITLE_CONSTANT = {
  PARTNER_TITLE: "Retail Partners",
  REWARDS_TITLE: "Rewards",
  CART_TITLE: "My Cart",
  ORDER_HISTORY_TITLE: "Order History",
  PAYMENT_TITLE: "Payment History",
  WISHLIST_TITLE: "Wishlist",
  PAYMENT_DETAILS: "Payment Detail",
  NOTIFICATIONS_TITLE: "Notifications",
};
